// @flow

import HomeApplication from 'models/HomeApplication';
import Asset from 'models/homes/Asset';

export const CREATE_HOME_APPLICATIONS: 'create/home_applications' =
  'create/home_applications';
export const EDIT_HOME_APPLICATION: 'edit/home_application' =
  'edit/home_application';
export const UPDATE_HOME_APPLICATIONS: 'update/home_applications' =
  'update/home_applications';
export const CANCEL_HOME_APPLICATION: 'cancel/home_application' =
  'cancel/home_application';
export const LIST_HOME_APPLICATIONS: 'list/home_applications' =
  'list/home_applications';
export const LIST_HOME_APPLICATION_ASSETS: 'list/home_application/asset' =
  'list/home_application/asset';
export const UPLOAD_HOME_APPLICATION_ASSET: 'upload/home_application/asset' =
  'upload/home_application/asset';
export const UPLOAD_HOME_APPLICATION_ASSET_FAILED: 'upload_failed/home_application/asset' =
  'upload_failed/home_application/asset';
export const SET_HOME_APPLICATION_MAX_ASSET_SIZE: 'set/home_application/max_asset_size' =
  'set/home_application/max_asset_size';
export const ADD_TEMP_HOME_APPLICATION_ASSET: 'add_temp/home_application/asset' =
  'add_temp/home_application/asset';
export const DELETE_HOME_APPLICATION_ASSET: 'delete/home_application/asset' =
  'delete/home_application/asset';
export const GET_HOME_APPLICATION_VALIDATE_PROMO_CODE: 'get/home_application/validate_promo_code' =
  'get/home_application/validate_promo_code';
export const GET_HOME_APPLICATION_VALIDATE_PROMO_CODE_ERROR: 'get/home_application/validate_promo_code_error' =
  'get/home_application/validate_promo_code_error';
export const GET_HOME_APPLICATION_UPDATE_ERROR: 'get/home_application_update_error' =
  'get/home_application_update_error';

export type Action =
  | {
      type: typeof LIST_HOME_APPLICATIONS,
      home_applications: Array<any>
    }
  | {
      type: typeof EDIT_HOME_APPLICATION,
      home_application: HomeApplication
    }
  | {
      type: typeof CREATE_HOME_APPLICATIONS,
      home_application: HomeApplication
    }
  | {
      type: typeof UPDATE_HOME_APPLICATIONS,
      home_application: HomeApplication
    }
  | {
      type: typeof CANCEL_HOME_APPLICATION
    }
  | {
      type: typeof LIST_HOME_APPLICATION_ASSETS,
      assets: Array<Asset>
    }
  | {
      type: typeof UPLOAD_HOME_APPLICATION_ASSET,
      asset: Asset,
      temp_asset_id: string
    }
  | {
      type: typeof UPLOAD_HOME_APPLICATION_ASSET_FAILED,
      temp_asset_id: string,
      asset_type: string,
      error: string
    }
  | {
      type: typeof SET_HOME_APPLICATION_MAX_ASSET_SIZE,
      max_asset_size: number
    }
  | {
      type: typeof ADD_TEMP_HOME_APPLICATION_ASSET,
      asset: Asset
    }
  | {
      type: typeof DELETE_HOME_APPLICATION_ASSET,
      asset_id: string,
      asset_type: string
    }
  | {
      type: typeof GET_HOME_APPLICATION_VALIDATE_PROMO_CODE,
      response: any
    }
  | {
      type: typeof GET_HOME_APPLICATION_VALIDATE_PROMO_CODE_ERROR,
      response: any
    }
  | {
      type: typeof GET_HOME_APPLICATION_UPDATE_ERROR,
      response: any
    };
